import { render } from "./SegmentStepperButton.vue?vue&type=template&id=83d55434"
import script from "./SegmentStepperButton.vue?vue&type=script&lang=js"
export * from "./SegmentStepperButton.vue?vue&type=script&lang=js"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStepperNavigation});
